import { COLOR4, RADIO_COLOR } from '../../constants';

export const ThankyouBundleStyles = {
  mainContainer: {
    width: '100%',
    minHeight: 'calc(100vh - 62px - 66px)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    '@media(max-width:600px)': {
      minHeight: 'calc(100vh - 44px - 66px)',
    },
  },

  thankyouGrid: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    maxWidth: '630px',
    gap: '48px',
    margin: '48px 24px',
    '@media(max-width:600px)': {
      margin: '36px 24px 24px 24px',
      maxWidth: '327px',
    },
  },

  sectionContainer1: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '18px',
  },

  text1: {
    fontFamily: 'TTNORMSPROBOLD',
    fontWeight: '700',
    fontSize: '2.25rem',
    lineHeight: '100%',
    letterSpacing: '0px',
    fontStyle: 'normal',
    color: '#000000',
    textAlign: 'center',
  },

  sectionContainer2: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'start',
    justifyContent: 'center',
    gap: '24px',
  },

  text2: {
    font: 'normal 700 20px/100% Arial',
    letterSpacing: '0px',
    color: '#F58220',
    textAlign: 'start',
  },

  iconGrid: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'start',
    justifyContent: 'start',
    gap: '12px',
  },

  iconGridText: {
    font: 'normal 700 16px/20px Arial',
    letterSpacing: '0px',
    textAlign: 'start',
  },

  bankingButton: {
    height: '48px',
    borderRadius: '56px',
    padding: '14px 50px',
    gap: '10px',
    font: 'normal 700 16px/20px Arial',
    letterSpacing: '0px',
    opacity: 1,
    textTransform: 'none',
    textAlign: 'center',
    '&:focus': {
      outline: `2px solid ${RADIO_COLOR}`,
      outlineOffset: `2px`,
    },
  },
};
